<template>
  <router-view></router-view>
</template>

<style>
.card-title {
  font-weight: bold;
}

.multiselect.is-invalid {
  border-color: var(--vz-form-invalid-border-color) !important;
  padding-right: calc(1.5em + 1rem) !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23f06548%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23f06548%27 stroke=%27none%27/%3e%3c/svg%3e") !important;
  background-repeat: no-repeat !important;
  background-position: right calc(0.375em + 0.25rem) center !important;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem) !important;
}

.multiselect.is-disabled {
  background-color: var(--vz-tertiary-bg) !important;
}

.btn-light {
  background-color: var(--vz-gray-500) !important;
  color: white !important;
}
</style>

<script>
import { isJwtExpired } from "../src/service/auth"; // Adjust path based on your project structure
// import { createApp } from "vue";
// import App from "./App.vue";

// createApp(App).mount("#app");

export default {
  name: "App",
  mounted() {
    const token = localStorage.getItem("jwt"); // Retrieve the JWT token
    if (token && isJwtExpired(token)) {
      console.warn("JWT has expired. Logging out...");
      this.handleLogout();
    }
  },
  methods: {
    handleLogout() {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (this.$route.path === "/login") {
        // Use this.$route in Vue 2
        this.$router.push("/"); // Use this.$router in Vue 2
      }
    },
  },
};
</script>
